/*
 * "That worked" — shared by the membership plans page and the your-membership
 * page.
 *
 * A downgrade does not take effect today. The page reloads after a change and
 * still shows the old tier, correctly, because that is what the member still
 * has until their renewal. Without being told, that reads as the change having
 * failed, and the next thing that happens is an email asking why it did not
 * work. So it says what changed, and when it starts.
 *
 * The reload waits for the dialog to be closed. Reloading underneath it would
 * take the explanation away before it had been read.
 */
(function () {
  'use strict';

  function titleCase(value) {
    var text = String(value || '').trim();
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  function longDate(value) {
    if (!value) return '';
    var when = new Date(value);
    if (isNaN(when.getTime())) return '';
    /*
     * Rendered in UTC, not the reader's zone. Shopify dates the change at UTC
     * midnight, and formatting that locally rolls it back a day for everybody
     * west of Greenwich — a member in New York was being told 3 October for a
     * renewal Shopify has on the 4th, which is the one number in this dialog
     * they might act on.
     */
    try {
      return when.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
      });
    } catch (error) {
      return when.toISOString().slice(0, 10);
    }
  }

  /* Lifted to <body>: a transformed ancestor becomes the containing block for
     position:fixed, and this theme transforms <main> mid-transition. Any copy
     left on <body> by a previous visit is cleared first, or a document-wide
     lookup finds the stale one. */
  function locate(root) {
    var dialog = root ? root.querySelector('[data-od-done]') : null;

    if (dialog) {
      var stale = document.querySelectorAll('body > .od-done[data-od-done]');
      for (var i = 0; i < stale.length; i++) {
        if (stale[i] !== dialog && stale[i].parentNode) {
          stale[i].parentNode.removeChild(stale[i]);
        }
      }
      if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
      return dialog;
    }

    return document.querySelector('body > .od-done[data-od-done]');
  }

  /**
   * @param result  the change-tier response: direction, fromTier, toTier,
   *                appliedImmediately, effectiveFrom
   * @param options { root, onClose }
   */
  function show(result, options) {
    var settings = options || {};
    var dialog = locate(settings.root || document);
    var done = settings.onClose || function () {};

    var newTier = titleCase(result && result.toTier);
    var oldTier = titleCase(result && result.fromTier);
    var immediate = !!(result && result.appliedImmediately);
    var when = longDate(result && result.effectiveFrom);

    var body = immediate
      ? 'You have successfully changed your membership tier to ' +
        newTier +
        '. All of the new benefits take effect starting now.'
      : 'You successfully changed your membership tier to ' + newTier + '.';

    var note = immediate
      ? ''
      : when
        ? 'You will continue to enjoy the benefits of ' + oldTier + ' until ' + when + '.'
        : 'You will continue to enjoy the benefits of ' +
          oldTier +
          ' until your next renewal.';

    /* No dialog to show it in is not a reason to say nothing: a member who has
       just downgraded and sees their old tier needs the explanation more than
       they need it to be pretty. */
    var title = dialog && dialog.querySelector('[data-od-done-title]');
    var bodyEl = dialog && dialog.querySelector('[data-od-done-body]');
    var noteEl = dialog && dialog.querySelector('[data-od-done-note]');

    if (!dialog || !title || !bodyEl || !noteEl) {
      window.alert(note ? body + '\n\n' + note : body);
      done();
      return;
    }

    title.textContent = 'Membership changed';
    bodyEl.textContent = body;
    noteEl.textContent = note;
    noteEl.hidden = !note;

    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      dialog.classList.remove('is-open');
      window.setTimeout(function () {
        dialog.hidden = true;
        done();
      }, 180);
    }

    if (dialog.dataset.odDoneBound !== '1') {
      dialog.dataset.odDoneBound = '1';
      dialog.addEventListener('click', function (event) {
        if (event.target.hasAttribute('data-od-done-close')) {
          if (dialog.__odClose) dialog.__odClose();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!dialog.isConnected || dialog.hidden) return;
        if (dialog.__odClose) dialog.__odClose();
      });
    }
    dialog.__odClose = close;

    dialog.hidden = false;
    void dialog.offsetWidth;
    dialog.classList.add('is-open');

    var go = dialog.querySelector('.od-done__go');
    if (go) go.focus();
  }

  window.ODMembershipDone = { show: show };
})();
